import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import * as Divider_tokens from './Divider.tokens.js';
import { divider as divider$1 } from './Divider.tokens.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["color", "variant", "size"];
var divider = divider$1;
var StyledDivider = styled.hr.withConfig({
  displayName: "Divider__StyledDivider",
  componentId: "sc-1d8osde-0"
})(function (_ref) {
  var backgroundColor = _ref.backgroundColor,
    marginTop = _ref.marginTop,
    marginBottom = _ref.marginBottom,
    dividerHeight = _ref.dividerHeight;
  return css(["border:none;background-color:", ";margin-top:", ";margin-bottom:calc(", " - ", "px);height:", "px;"], backgroundColor, marginTop, marginBottom, dividerHeight, dividerHeight);
});
var Divider = /*#__PURE__*/forwardRef(function Divider(_ref2, ref) {
  var _ref2$color = _ref2.color,
    color = _ref2$color === void 0 ? 'medium' : _ref2$color,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'medium' : _ref2$variant,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? '1' : _ref2$size,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var colorValue = color === 'medium' ? 'mediumColor' : color;
  var props = _objectSpread({
    backgroundColor: divider[colorValue].background,
    marginTop: Divider_tokens[variant].spacings.top,
    marginBottom: Divider_tokens[variant].spacings.bottom,
    dividerHeight: parseInt(size)
  }, rest);
  return /*#__PURE__*/jsx(StyledDivider, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  }));
});

export { Divider };
